export default "__VITE_ASSET__5b90767d__"